module.exports = __webpack_public_path__ + "img/al4.631abef5.png";